import { PersonPanel } from "../PersonPanel"
import contactsIcon from "../../../assets/fonts/contactsList.svg"
import { PhoneNumberInput } from "../PhoneNumberInput"
import { Input } from "../Input"
import { FC } from "react"
import { FormikType } from "../../../types/VisitReports/types"
import "./styles.scss"
import { useTranslation } from "../../../hooks/useTranslation"
import { findCellPhone, findWorkPhone, findWorkExtension } from "../../../utils/phoneSlots"

type Props = {
  formik: FormikType
  personIndex: number
  path: "updated_persons" | "new_persons"
  setPhoneSlotValue: (slotType: "Mobile" | "Work", number: string) => void
  setWorkExtensionValue: (value: string) => void
  handleEmail: (e: any) => void
}

export const ContactInfo: FC<Props> = ({
  formik,
  personIndex,
  path,
  setPhoneSlotValue,
  setWorkExtensionValue,
  handleEmail,
}) => {
  const { p } = useTranslation('contact_info');
  const { p: pGeneral } = useTranslation('general');

  // Two fixed slots — Cell + Work. The house phone is a household-level field, edited once
  // in the home-details section (not per contact).
  const phones = formik?.values?.[path]?.[personIndex]?.phones || []
  const cell = findCellPhone(phones)?.number || ""
  const work = findWorkPhone(phones)?.number || ""
  const workExtension = findWorkExtension(phones)
  const hasWork = work.trim() !== ""

  return (
    <div className="visit-report-contact-info">
      <div className="visit-report-contact-info__panel">
        <PersonPanel icon={contactsIcon} title={p('name')} />
      </div>
      {/* Cell + Work share a row on desktop, stack on mobile. */}
      <div className="visit-report-contact-info__phone-row">
        <div className="visit-report-contact-info__phone">
          <PhoneNumberInput
            label={p('cell')}
            index="cell"
            type="Mobile"
            value={cell}
            onChange={(value) => setPhoneSlotValue("Mobile", value)}
          />
        </div>
        <div className="visit-report-contact-info__work">
          <div className="visit-report-contact-info__phone visit-report-contact-info__work-number">
            <PhoneNumberInput
              label={p('work')}
              index="work"
              type="Work"
              value={work}
              onChange={(value) => setPhoneSlotValue("Work", value)}
            />
          </div>
          <div className="visit-report-contact-info__ext">
            <Input
              label={p('extension')}
              placeholder={p('extension')}
              value={workExtension}
              onChange={(e: any) => setWorkExtensionValue(e.target.value)}
              disabled={!hasWork}
            />
          </div>
        </div>
      </div>
      <div className="visit-report-contact-info__email">
        <Input
          label={pGeneral('email')}
          placeholder={pGeneral('email')}
          value={formik?.values?.[path]?.[personIndex]?.email}
          onChange={handleEmail}
        />
      </div>
    </div>
  )
}
